import React from 'react';

import { AdminExportTable } from 'src/components';

import classes from './adminExport.module.scss';

export const AdminExport = () => {
  return (
    <div className={classes.AdminExport}>
      <AdminExportTable />
    </div>
  );
};
